"use client";

import { useState } from "react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const categories = [{
  id: "all",
  label: "All"
}, {
  id: "interior",
  label: "Interior Architecture"
}, {
  id: "residential",
  label: "Residential Architecture"
}, {
  id: "sustainable",
  label: "Sustainable Design"
}, {
  id: "urban",
  label: "Urban Planning"
}];
const projects = [{
  id: 1,
  category: "interior",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/modern_interior_living_space.png",
  height: "h-80"
}, {
  id: 2,
  category: "residential",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/contemporary_residential_exterior.png",
  height: "h-96"
}, {
  id: 3,
  category: "sustainable",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/eco_friendly_building_design.png",
  height: "h-72"
}, {
  id: 4,
  category: "urban",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/urban_plaza_planning.png",
  height: "h-88"
}, {
  id: 5,
  category: "interior",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/luxury_interior_bedroom.png",
  height: "h-84"
}, {
  id: 6,
  category: "residential",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/suburban_house_architecture.png",
  height: "h-80"
}, {
  id: 7,
  category: "sustainable",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/green_roof_building.png",
  height: "h-92"
}, {
  id: 8,
  category: "urban",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/city_park_development.png",
  height: "h-76"
}, {
  id: 9,
  category: "interior",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/minimalist_office_interior.png",
  height: "h-88"
}, {
  id: 10,
  category: "residential",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/modern_villa_exterior.png",
  height: "h-84"
}, {
  id: 11,
  category: "sustainable",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/solar_panel_architecture.png",
  height: "h-80"
}, {
  id: 12,
  category: "urban",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/mixed_use_development.png",
  height: "h-96"
}];
export default function PortfolioGallery() {
  const [activeCategory, setActiveCategory] = useState("all");
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const filteredProjects = activeCategory === "all" ? projects : projects.filter(p => p.category === activeCategory);
  return <section id="portfolio-gallery" ref={sectionRef} className="bg-primary py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-200 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <p className="text-sm text-accent tracking-widest uppercase mb-3">
            DATES FRESH UPDA
          </p>
          <h2 className="font-display text-5xl text-foreground-primary font-bold">
            Our Excellent Efforts
          </h2>
        </div>

        <div className={`flex justify-center mb-12 transition-all duration-200 delay-100 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <ToggleGroup type="single" value={activeCategory} onValueChange={value => value && setActiveCategory(value)} className="flex flex-wrap gap-3 justify-center">
            {categories.map(cat => <ToggleGroupItem key={cat.id} value={cat.id} data-index={cat.id} className={`
                  rounded-full px-6 py-3 font-semibold text-sm
                  transition-all duration-[120ms] ease-out
                  ${activeCategory === cat.id ? "bg-accent text-foreground-accent shadow-medium" : "bg-light-background text-foreground-light border border-border hover:border-accent hover:bg-primary-hover"}
                `}>
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-current mr-2" />
                {cat.label}
              </ToggleGroupItem>)}
          </ToggleGroup>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, i) => {
          const {
            ref: itemRef,
            isVisible: itemVisible
          } = useRevealOnScroll({
            threshold: 0.2,
            once: true
          });
          return <div key={project.id} data-index={i} ref={itemRef} className={`
                  ${project.height} rounded-xl overflow-hidden
                  transition-all duration-200 ease-out
                  hover:-translate-y-0.5 hover:shadow-medium
                  ${itemVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
                `} style={{
            transitionDelay: `${i * 50}ms`
          }}>
                <img src={project.image} alt={`Portfolio project ${project.id}`} className="w-full h-full object-cover" />
              </div>;
        })}
        </div>
      </div>
    </section>;
}